import transform from 'lodash/transform';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';

export default function cleanDeep(object: any) {
    if (!isPlainObject(object)) {
        return object;
    }

    return transform(object, (acc, value, key) => {
        if (isPlainObject(value)) {
            value = cleanDeep(value);

            if (isEmpty(value)) {
                return;
            }
        }

        acc[key] = value;
    });
}
